import React from "react"
import { Box } from "@rebass/grid/emotion"

const Col = props => <Box {...props} px={3} mb={3} />

export default Col
